/** @jsx jsx */

import React, { Fragment as _, useRef, useEffect } from 'react';
import { css, jsx } from '@emotion/core';
import Modal from 'components/UI/Modal';

const Transcript = ({
  onClose,
  children,
}: {
  id?: any;
  onClose?: any;
  children?: any;
}) => {
  let [text, btn] = children[0].props.children;

  btn = React.cloneElement(btn, {
    onClick() {
      onClose();
    },
  });

  const buttonContainer = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!buttonContainer.current) {
      return;
    }

    const continueButton = buttonContainer.current.querySelector(
      'button'
    ) as HTMLButtonElement;
    if (!continueButton) {
      return;
    }

    continueButton.removeAttribute('aria-label');
  }, []);

  return (
    <Modal onClose={onClose}>
      <div
        css={css`
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: space-between;
          width: 100%;
          min-height: 50vh;
          padding: 30px;
        `}
      >
        <div
          css={css`
            display: flex;
            flex: 1;
            align-items: center;
            margin: 0 0 20px 0;
          `}
        >
          {text}
        </div>
        <div
          css={css`
            display: flex;
            justify-content: center;
            width: 100%;
          `}
        >
          <div ref={buttonContainer}>{btn}</div>
        </div>
      </div>
    </Modal>
  );
};

export default Transcript;
